// @generated by protoc-gen-es v2.10.0 with parameter "target=ts,import_extension=none"
// @generated from file proto/sem/middleware/thinking_mode.proto (package sem.middleware.thinking_mode, syntax proto3)
/* eslint-disable */

import type { JsonObject, Message } from "@bufbuild/protobuf";
import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file proto/sem/middleware/thinking_mode.proto.
 */
export const file_proto_sem_middleware_thinking_mode: GenFile = /*@__PURE__*/
  fileDesc("Cihwcm90by9zZW0vbWlkZGxld2FyZS90aGlua2luZ19tb2RlLnByb3RvEhxzZW0ubWlkZGxld2FyZS50aGlua2luZ19tb2RlInIKE1RoaW5raW5nTW9kZVBheWxvYWQSDAoEbW9kZRgBIAEoCRINCgVwaGFzZRgCIAEoCRIRCglyZWFzb25pbmcYAyABKAkSKwoKZXh0cmFfZGF0YRgKIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QiZwoTVGhpbmtpbmdNb2RlU3RhcnRlZBIPCgdpdGVtX2lkGAEgASgJEj8KBGRhdGEYAiABKAsyMS5zZW0ubWlkZGxld2FyZS50aGlua2luZ19tb2RlLlRoaW5raW5nTW9kZVBheWxvYWQiZgoSVGhpbmtpbmdNb2RlVXBkYXRlEg8KB2l0ZW1faWQYASABKAkSPwoEZGF0YRgCIAEoCzIxLnNlbS5taWRkbGV3YXJlLnRoaW5raW5nX21vZGUuVGhpbmtpbmdNb2RlUGF5bG9hZCKJAQoVVGhpbmtpbmdNb2RlQ29tcGxldGVkEg8KB2l0ZW1faWQYASABKAkSPwoEZGF0YRgCIAEoCzIxLnNlbS5taWRkbGV3YXJlLnRoaW5raW5nX21vZGUuVGhpbmtpbmdNb2RlUGF5bG9hZBIPCgdzdWNjZXNzGAMgASgIEg0KBWVycm9yGAQgASgJQlZaVGdpdGh1Yi5jb20vdGVhbS1tZW50by9tZW50by1wbGF5Z3JvdW5kL2dvL3BrZy9zZW0vcGIvcHJvdG8vc2VtL21pZGRsZXdhcmU7bWlkZGxld2FyZWIGcHJvdG8z", [file_google_protobuf_struct]);

/**
 * Payload for thinking mode messages
 *
 * @generated from message sem.middleware.thinking_mode.ThinkingModePayload
 */
export type ThinkingModePayload = Message<"sem.middleware.thinking_mode.ThinkingModePayload"> & {
  /**
   * @generated from field: string mode = 1;
   */
  mode: string;

  /**
   * @generated from field: string phase = 2;
   */
  phase: string;

  /**
   * @generated from field: string reasoning = 3;
   */
  reasoning: string;

  /**
   * Additional unstructured data from extractor
   *
   * @generated from field: google.protobuf.Struct extra_data = 10;
   */
  extraData?: JsonObject;
};

/**
 * Describes the message sem.middleware.thinking_mode.ThinkingModePayload.
 * Use `create(ThinkingModePayloadSchema)` to create a new message.
 */
export const ThinkingModePayloadSchema: GenMessage<ThinkingModePayload> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_thinking_mode, 0);

/**
 * @generated from message sem.middleware.thinking_mode.ThinkingModeStarted
 */
export type ThinkingModeStarted = Message<"sem.middleware.thinking_mode.ThinkingModeStarted"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.thinking_mode.ThinkingModePayload data = 2;
   */
  data?: ThinkingModePayload;
};

/**
 * Describes the message sem.middleware.thinking_mode.ThinkingModeStarted.
 * Use `create(ThinkingModeStartedSchema)` to create a new message.
 */
export const ThinkingModeStartedSchema: GenMessage<ThinkingModeStarted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_thinking_mode, 1);

/**
 * @generated from message sem.middleware.thinking_mode.ThinkingModeUpdate
 */
export type ThinkingModeUpdate = Message<"sem.middleware.thinking_mode.ThinkingModeUpdate"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.thinking_mode.ThinkingModePayload data = 2;
   */
  data?: ThinkingModePayload;
};

/**
 * Describes the message sem.middleware.thinking_mode.ThinkingModeUpdate.
 * Use `create(ThinkingModeUpdateSchema)` to create a new message.
 */
export const ThinkingModeUpdateSchema: GenMessage<ThinkingModeUpdate> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_thinking_mode, 2);

/**
 * @generated from message sem.middleware.thinking_mode.ThinkingModeCompleted
 */
export type ThinkingModeCompleted = Message<"sem.middleware.thinking_mode.ThinkingModeCompleted"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.middleware.thinking_mode.ThinkingModePayload data = 2;
   */
  data?: ThinkingModePayload;

  /**
   * @generated from field: bool success = 3;
   */
  success: boolean;

  /**
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message sem.middleware.thinking_mode.ThinkingModeCompleted.
 * Use `create(ThinkingModeCompletedSchema)` to create a new message.
 */
export const ThinkingModeCompletedSchema: GenMessage<ThinkingModeCompleted> = /*@__PURE__*/
  messageDesc(file_proto_sem_middleware_thinking_mode, 3);

